import { useContext } from 'react'
import { useRouter } from 'next/router'
import { AuthContext } from '../context/auth'

// Thin wrapper kept for the existing read-only consumers (they only use
// `currentUser` for truthiness). Replaces the old Amplify Hub listener.
export interface UseAuthHookResponse {
  currentUser: { email: string } | null
  signIn: () => void
  signOut: () => void
}

const useAuth = (): UseAuthHookResponse => {
  const { session, setUserSession, removeUser } = useContext(AuthContext)
  const router = useRouter()

  return {
    currentUser: session ? { email: session.email } : null,
    signIn: () => router.push('/login'),
    signOut: () => {
      setUserSession(null)
      removeUser()
    },
  }
}

export { useAuth }
